





















import { Vue, Component, Prop } from "vue-property-decorator";
import moment from "moment";
import CONST_DATA from "@/general/mixins/const/constData";

@Component
export default class TopNewsNormal extends Vue {
  @Prop({ type: Array }) item_list!: any;

  get urlWhatsNewDetail() {
    return CONST_DATA.SITE_MAP.WHATS_NEW_DETAILS;
  }

  formatDate(date: string) {
    return moment(new Date(date)).format("YYYY年MM月DD日");
  }
}
